import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import encode from "nodejs-base64-encode";

function AbonosFacturasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS_FACTURAS = process.env.REACT_APP_URL_ABONOS_FACTURAS;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_COUNTERS = process.env.REACT_APP_URL_COUNTERS;
  const [text, setText] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [counters, setCounters] = useState([]);
  const [fecha, setFecha] = useState("");
  const [fecha_visita, setFechaVisita] = useState("");
  const [importe, setImporte] = useState("");
  const [forma_pago, setFormaPago] = useState("");
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedFactura, setSelectedFactura] = useState("");
  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);

 function clear(){
    setSelectedCliente("")
    setFecha("")
    setImporte("")
    setFormaPago("")
    setFormaPago("")
    setFechaVisita("")
    setValidaBoton(true)
    setValue("")
    setSelectedFactura("")
    setFacturas([])
   
    axios
    .get(URL_COUNTERS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allCounters = response.data;
      setCounters(allCounters);
    })
    .catch((err) => {
      console.log(err);
    });

 numero = counters
  .map((c) => {
    if (c.id == "idAbonoFactura") {
      return c.seq + 1;
    } else return null;
  })
  .filter(function (el) {
    return el != null;
  });
  }

  
  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COUNTERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allCounters = response.data;
        setCounters(allCounters);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  let numero = counters
    .map((c) => {
      if (c.id == "idAbonoFactura") {
        return c.seq + 1;
      } else return null;
    })
    .filter(function (el) {
      return el != null;
    })

    
  const savePago = (event) => {
    numero = counters
  .map((c) => {
    if (c.id == "idAbonoFactura") {
      return c.seq + 1;
    } else return null;
  })
  .filter(function (el) {
    return el != null;
  })
    event.preventDefault();
    setValidaBoton(false)
    const URL_CLIENTES_RECIBO = `${process.env.REACT_APP_URL_CLIENTES}/${value._id}`;
    axios
      .get(URL_CLIENTES_RECIBO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        var ND = response.data.nombre;
        var AD = response.data.apellido;
        var NC = response.data.nombre_comercial
        const doc = new jsPDF();
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        // Horizontal, Vertical, Ancho, Alto
        doc.addImage(img, "png", 150, 10, 35, 10);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        // Horizontal, Vertical, Ancho, Alto
        doc.addImage(img2, "png", 140, 20, 60, 25);
        // Horizontal, Vertical
        doc.setFontSize(16);
        doc.text(`${process.env.REACT_APP_NOMBRE_INSTITUCION}`, 65, 65);
        doc.text(`__________________`, 80, 100);
        doc.text(`Firma`, 100, 110);
        doc.autoTable({
          head: [["No Recibo", "Fecha", "Cliente", "Importe"]],
          body: [
            [
              numero,
              fecha,
              [ND + " " + AD + " / " + NC],
              "$" + new Intl.NumberFormat("en-US").format(importe),
            ],
          ],
          startY: 70,
        });

        var att = doc.output("arraybuffer");
        var base64File = encode.encode(att, "base64");
        
        axios.post(
            URL_ABONOS_FACTURAS,
            {
              fecha,
              importe,
              forma_pago,
              clientes: value._id,
              base64File,
              fecha_visita,
              ultimo_pago:fecha,
              user: user.id,
              facturas:selectedFactura
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              doc.save(`Recibo-${numero}.pdf`);
              clear()
            }, 2000);
          })            
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
        setValidaBoton(true)
      });
  };

  const options = clientes.map((option) => {
    const junta =
      option.apellido + " " + option.nombre + " / " + option.nombre_comercial;
    const firstLetter = option.apellido[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });


const selectCliente = (e)=>{
  setSelectedCliente(e.target.value);
const URL_FACTURAS_CLIENTE = `${process.env.REACT_APP_URL_FACTURAS}/cliente/${value._id}`
axios
    .get(`${URL_FACTURAS_CLIENTE}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allFacturas = response.data;
      setFacturas(allFacturas);
    })
    .catch((err) => {
      console.log(err);
    })
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturas_abonos_create ? (
        <div className="container">
          <div className="card container col-sm-6">
            <h3 align="center">Captura un pago de Nota</h3>
            <Form onSubmit={savePago}>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      setValue(selectedCliente);
                    }}
                    onBlur={selectCliente}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.apellido} {option.nombre} /{" "}
                        {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col>
                <Label className="mr-sm-2">Notas</Label>
                <Input
                    type="select"
                    placeholder="Notas"
                    value={selectedFactura}
                    required
                    onChange={(e) => {
                      setSelectedFactura(e.target.value)
                    }}
                  >
                     <option value="0">Selecciona</option>
                {facturas
                  .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
                  .map((a) => {
                    if (a.saldo!==0) {
                    return <option value={a._id}>#{a.nota} / Importe ${new Intl.NumberFormat("en-US").format(a.importe)} / Saldo ${new Intl.NumberFormat("en-US").format(a.saldo)} </option>
                    }
                  })}
                  </Input>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label>Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={6}>
                  <Label>Importe</Label>
                  <Input
                    className="col-sm-12"
                    type="number"
                    placeholder="Importe"
                    value={importe}
                    required
                    onChange={(e) => {
                      setImporte(e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Label>Forma de Pago</Label>
                  <Input
                    type="select"
                    placeholder="Forma de Pago"
                    value={forma_pago}
                    required
                    onChange={(e) => {
                      setFormaPago(e.target.value);
                    }}
                  >
                    <option value="0">Forma de Pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Deposito">Deposito</option>
                    <option value="TDC">TDC</option>
                    <option value="Cheque">Cheque</option>
                  </Input>
                </Col>
              <Col md={6}>
                  <Label>Proxima Visita</Label>
                  <Input
                    type="date"
                    value={fecha_visita}
                    required
                    onChange={(e) => {
                      setFechaVisita(e.target.value);
                    }}
                  />
                </Col>
              </Row>

              <br />
              <Row>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                  Registrar
                </Button>
                ):(
                <Button type="submit" className="btn btn-success" disabled>
                  Registrar
                </Button>)}
                
                <div>
                  <SweetAlert
                    show={text}
                    title="Creado con Exito"
                    onConfirm={() => {
                      setText(false);
                    }}
                  />
                </div>
                <Button
                  href="/AbonosClientes"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Row>
            </Form>
          </div>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosFacturasCreate;
